import React, { useState, useEffect } from 'react';
import { Tooltip, Checkbox } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import style from './index.module.scss';
import { ReactComponent as IconWarn } from '@/images/icons/icon-warn.svg';
import { useAppDispatch } from '@web-common/state/createStore';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { useAppSelector } from '@web-common/state/createStore';
import { apiHolder, apis, inWindow } from 'api';
import { getIn18Text } from 'api';
const nimApi = apiHolder.api.requireLogicalApi(apis.imApiImpl);
const ReadRemindComp = (props) => {
    let { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const curAccount = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSender; });
    const readRemind = useAppSelector(state => state.mailReducer.currentMail.senderReceivers);
    const isMainAccount = curAccount === null || curAccount === void 0 ? void 0 : curAccount.isMainAccount;
    const dispatch = useAppDispatch();
    const [titleRender, setTitleRender] = useState('');
    useEffect(() => {
        if (!inWindow()) {
            return;
        }
        if (productVersionId !== 'sirius') {
            setTitleRender(getIn18Text('GOUXUANCIGONGNENG'));
            return;
        }
        setTitleRender(getIn18Text('GOUXUANCIGONGNENG11'));
    }, [productVersionId]);
    const readRemindChange = () => {
        if (!nimApi.getIMAuthConfig()) {
            dispatch(mailActions.doChangeMailReadRemind(!readRemind));
            return;
        }
        if (!readRemind) {
            message.success({
                content: productVersionId === 'sirius' ? getIn18Text('YIKAIQI\uFF0CDUI11') : getIn18Text('YIKAIQI\uFF0CDUI'),
            });
        }
        else {
            message.success({
                content: getIn18Text('YIGUANBI\uFF0CDUI'),
            });
        }
        dispatch(mailActions.doChangeMailReadRemind(!readRemind));
    };
    return (React.createElement("div", { className: `${style.readRemind}` },
        React.createElement(Checkbox, { checked: readRemind, disabled: !isMainAccount, onClick: readRemindChange }, getIn18Text('YIDUTIXING')),
        React.createElement(Tooltip, { arrowPointAtCenter: true, getPopupContainer: () => document.getElementById('sendfooter') || document.body, placement: "topLeft", title: titleRender },
            React.createElement(IconWarn, null))));
};
export default ReadRemindComp;
